import React, { Component, Fragment } from "react";

export default class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Footer"
        }
    }

    render() {
        return (
            <Fragment>
                <footer className="footer footer-black footer-white ">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="credits ml-auto">
                                <span className="copyright">
                                    © {new Date().getFullYear()}, SENAI - Sistema de Gerenciamento de Metas (SIGEM) | Versão BETA v0.1.5
                                </span>
                            </div>
                        </div>
                    </div>
                </footer>
            </Fragment>
        )
    }
}



